import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Scan, History } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const HIDDEN_PATHS = ["/login", "/scanner", "/camera", "/dark-spot", "/mms-blister-detection", "/ttd-detection"];

const BottomNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  // Hide on login, scanning pages, or if not authenticated
  if (!user || HIDDEN_PATHS.includes(location.pathname)) {
    return null;
  }

  const navItems = [
    {
      name: "Home",
      path: "/",
      icon: Home,
      isActive: (pathname) => pathname === "/" || pathname === "/dashboard",
    },
    {
      name: "Scan",
      path: "/scanner",
      icon: Scan,
      isActive: (pathname) =>
        pathname === "/scanner" ||
        pathname === "/camera" ||
        pathname === "/dark-spot" ||
        pathname === "/mms-blister-detection" ||
        pathname === "/ttd-detection" ||
        pathname === "/results",
    },
    {
      name: "History",
      path: "/history",
      icon: History,
      isActive: (pathname) => pathname === "/history",
    },
  ];

  return (
    <nav
      aria-label="Mobile Bottom Navigation"
      data-testid="bottom-navigation"
      className="fixed bottom-4 inset-x-4 z-40 max-w-md mx-auto bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl border border-gray-200/80 dark:border-gray-800/80 rounded-2xl shadow-xl shadow-black/10 dark:shadow-black/50 px-2 py-2 transition-all duration-300"
    >
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const active = item.isActive(location.pathname);
          const Icon = item.icon;

          return (
            <button
              key={item.name}
              type="button"
              onClick={() => navigate(item.path)}
              aria-label={item.name}
              aria-current={active ? "page" : undefined}
              className={`flex flex-col items-center justify-center flex-1 py-1.5 px-3 rounded-xl transition-all duration-200 ${
                active
                  ? "text-blue-600 dark:text-blue-400 font-semibold scale-105"
                  : "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium"
              }`}
            >
              <div
                className={`p-1 rounded-lg transition-colors ${
                  active
                    ? "bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400"
                    : "text-gray-500 dark:text-gray-400"
                }`}
              >
                <Icon
                  className={`h-5 w-5 ${
                    active ? "stroke-[2.5]" : "stroke-[1.75]"
                  }`}
                />
              </div>
              <span className="text-[11px] mt-0.5 leading-none">
                {item.name}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
